module.exports = __webpack_public_path__ + "static/media/CloudCoffer-logo-flat.4a94ea3f.jpg";